import React from "react";
import { Activity, BarChart3, Sparkles, ShieldCheck } from "lucide-react";
import { HIGHLIGHTS } from "../mock";

const ICONS = { Activity, BarChart3, Sparkles, ShieldCheck };

export default function Highlights() {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-400/10 border border-amber-400/20 text-amber-300 text-xs font-medium tracking-wide">
            Why Madhur Lottery
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl font-bold text-slate-100">
            Daily updates, full history,{" "}
            <span className="text-amber-300">one trusted hub</span>
          </h2>
          <p className="mt-3 text-slate-400">
            Live results, year-wise chart archive aur Starline records — sab kuch ek hi jagah par.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {HIGHLIGHTS.map((h) => {
            const Icon = ICONS[h.icon];
            return (
              <div
                key={h.title}
                className="group rounded-2xl border border-white/5 bg-[#11172a] p-6 hover:border-amber-400/30 hover:-translate-y-0.5 transition-all"
              >
                <div className="w-11 h-11 rounded-xl bg-amber-400/10 border border-amber-400/20 flex items-center justify-center mb-4 group-hover:bg-amber-400/20">
                  <Icon className="w-5 h-5 text-amber-300" />
                </div>
                <h3 className="text-base font-semibold text-slate-100">{h.title}</h3>
                <p className="mt-1.5 text-sm text-slate-400 leading-relaxed">{h.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
